/* unplugin-vue-components disabled */import { render } from "./Loading.vue?vue&type=template&id=cfa56fcc"
const script = {}

import "./Loading.vue?vue&type=style&index=0&id=cfa56fcc&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__